export default __webpack_public_path__ + "assets/images/7.eeaf43.png";